import { jsx as _jsx } from "react/jsx-runtime";
/* Auto-generated. Do not edit! */
/* eslint-disable */

const SvgHeart = props => /*#__PURE__*/_jsx("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: 24,
  height: 24,
  viewBox: "0 0 24 24",
  fill: "rgb(0 0 0 / 60%)",
  ...props,
  children: /*#__PURE__*/_jsx("path", {
    fill: "#425CCD",
    stroke: "#425CCD",
    strokeWidth: 1.5,
    d: "M15.97 13.97a89.756 89.756 0 0 1-3.312 3.112l-.658.59-.658-.59A89.757 89.757 0 0 1 8.03 13.97c-.864-.864-1.537-1.626-2.028-2.287-.492-.662-.81-1.239-.985-1.732A4.63 4.63 0 0 1 4.75 8.4c0-1.067.35-1.919 1.04-2.61.691-.69 1.543-1.04 2.61-1.04.584 0 1.135.123 1.662.37.528.246.982.593 1.367 1.046l.571.672.572-.672c.384-.453.838-.8 1.366-1.047A3.865 3.865 0 0 1 15.6 4.75c1.067 0 1.919.35 2.61 1.04.69.691 1.04 1.543 1.04 2.61a4.63 4.63 0 0 1-.267 1.55c-.174.494-.493 1.07-.985 1.733-.491.66-1.164 1.423-2.028 2.287Z"
  })
});
export default SvgHeart;